import type { Priority } from '~/types';

export type GetClientTaskByIdRequest = { clientTaskId: string };

export type GetClientTaskByIdResponse = {
  item: GetClientTaskByIdResponseItem;
};

export type GetClientTaskByIdResponseItem = ClientTaskBaseResponseItem & {
  _id: string;
  orgId: string;
  inventory: string;
  rollout: {
    identifier: string;
    _id: string;
  };
  taskNumber: number;
  assignee?: {
    _id: string;
    name: string;
    picture?: string;
    email: string;
    role: string;
  };
  createdBy: {
    _id: string;
    name: string;
    picture?: string;
    email: string;
    role: string;
  };
  client: {
    _id: string;
    name: string;
    rollout: string;
    clientUser: {
      _id: string;
      name: string;
      email: string;
    };
  };
  created: string;
  updated: string;
  taskIdentifier: string;
};

export type ClientTaskBaseResponseItem = {
  name: string;
  description: string;
  priority: Priority;
  date?: string;
  duration: number;
  done?: boolean;
  startTime?: string;
  endTime?: string;
  isAllDayTask?: boolean;
};

export type CreateClientTaskRequest = ClientTaskBaseResponseItem & {
  clientId: string;
  assigneeId?: string;
  recipients?: string[];
};

export type CreateClientTaskRespones = {
  item: ClientTaskBaseResponseItem & {
    _id: string;
    orgId: string;
    inventory: string;
    rollout: string;
    taskNumber: number;
    assignee?: string;
    createdBy: string;
    client: string;
    created: string;
    updated: string;
  };
};

export type ClientTaskDeleteByIdsRequest = {
  clientTaskIds: string[];
};

export type ClientTaskDeleteByIdsResponse = { message: string };

export function useApiClientTask() {
  const { $client } = useNuxtApp();

  const getClientTaskById = async (
    request: GetClientTaskByIdRequest
  ): Promise<GetClientTaskByIdResponse> => {
    const response = await $client.clientTask.getClientTaskById.query(request);

    return response;
  };

  const create = async (
    request: CreateClientTaskRequest
  ): Promise<CreateClientTaskRespones> => {
    const response = await $client.clientTask.create.mutate(request);

    return response;
  };

  const deleteByIds = async (
    request: ClientTaskDeleteByIdsRequest
  ): Promise<ClientTaskDeleteByIdsResponse> => {
    return await $client.clientTask.deleteByIds.mutate(request);
  };

  return { getClientTaskById, create, deleteByIds };
}
